import {useState} from 'react'
import { useHistory } from 'react-router-dom';

const AddProfile = ({language, isVisible, setIsVisible, profiles, setProfiles}) => {
    const [profileName, setProfileName] = useState()
    const [isReadonly, setIsReadonly] = useState(false)
    const history = useHistory();
    let solutionId = global.config.Editor.solutionId

    const handleClose = async e => {
        e.preventDefault();
        setProfileName('')
        setIsReadonly(false)
        setIsVisible(isVisible ? false : true)
    }
    
    const postContentType = async () => {

        var graphql = JSON.stringify({
            query: `mutation ($profileName: String, $isReadonly: Boolean, $solutionId: Long){
                        addProfile(profileName:$profileName, isReadonly:$isReadonly, solutionId:$solutionId) {
                            id
                            profileName
                            isReadonly
                            solutionId
                        }
                    }`,
            variables: {
                "profileName": profileName
                ,"isReadonly": isReadonly
                ,"solutionId": solutionId
            }
            
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {
            var resultData = JSON.parse(result).data
            if(resultData.addProfile){
                setProfiles(...profiles, resultData.addProfile)
                history.push(`/settings/profiles/${resultData.addProfile.id}`)
            }
            return 
        })
        .catch(error => console.log('error', error))
        const data = await res
        
        return data

    }

    const handleSave = async e => {
        e.preventDefault();
        var error = false
        if(profileName === ""){
            error = true
        }
        if(!error){
            await postContentType()
        }
    }

    return (
        <div id="cc_editarticle" className={isVisible ? '' : 'hidden'} >
            <div className="close-container">
                <span className="result_response"></span>
                <button onClick={handleClose}><i className="sprite-icon icon-close"></i></button>
            </div>
            <h3>{language.value === 'DA' ? 'Tilføj ny Profil' : 'Add new Profile'}</h3>
            <div id="cc_article_container">
                <div id="articletype_list">
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Navn' : 'Name'}</span>
                        <input type="text" name="profileName" value={profileName} onChange={ e => setProfileName(e.target.value)} autoComplete="off"/>
                    </label>
                    <label className="input_label checkbox">
                        <input type="checkbox" name="isReadonly" checked={isReadonly} onChange={ e => setIsReadonly(isReadonly ? false : true) } />
                        <span>{language.value === 'DA' ? 'Kun med læserettigheder' : 'Readonly'}</span>
                    </label>
                </div>
                
                <div className="align_right">
                    <button onClick={handleSave} className="cc-btn blue-gradient">{language.value === 'DA' ? 'OPRET PROFIL' : 'CREATE PROFILE'}</button>
                </div>
            </div>
        </div>
    )
}

export default AddProfile
